import { Col, Row, Table } from 'react-bootstrap';
import { getBoolean, getMedicalStatus, getNumber, getString, getYesNoUnknown } from './renderers';
import { IDonorRegistration } from '@nkr/models/index';
import { CancerType, RemissionStatus } from '@nkr/enums/index';
import { cardBodyStyle, cardBodyTitleStyle, cardStyle, cardBodyTitleTextStyle } from '../../styles';

interface IProps {
    data: IDonorRegistration
}

const PreScreening = (props: IProps) => {
    return (
        <div id='pre-screening' style={cardStyle}>
            <div style={cardBodyStyle}>
                <div style={cardBodyTitleStyle}>
                    <span style={cardBodyTitleTextStyle}>Living Donor Pre-Screening</span>
                </div>
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Is In U.S.?</Col>
                    <Col xs={6} sm={4}>
                        {getBoolean(props.data.isResidingInUsa, false)}
                    </Col>
                </Row>

                {!props.data.isResidingInUsa && (
                    <>
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>&nbsp; - Is seeking compensation?</Col>
                            <Col xs={6} sm={4}>{getBoolean(props.data.isDonatingForCompensation)}</Col>
                        </Row>
                    </>
                )}

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Will Accept Blood Transfusions?</Col>
                    <Col xs={6} sm={4}>{getBoolean(props.data.willAcceptTransfusions, false)}</Col>
                </Row>

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Has been diagnosed with Nutcracker Syndrome?</Col>
                    <Col xs={6} sm={4}>{getYesNoUnknown(props.data.hasNutcracker)}</Col>
                </Row>

                {props.data.hasNutcracker == "Yes" && (
                    <>
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>&nbsp; - Was the nutcracker treated?</Col>
                            <Col xs={6} sm={4}>{getBoolean(props.data.wasNutcrackerTreated, false)}</Col>
                        </Row>
                        {props.data.wasNutcrackerTreated == true && (
                            <Row className='row-underlined row-value-center'>
                                <Col xs={6} sm={8} className='item-label'>&nbsp; - Nutcracker treatment?</Col>
                                <Col xs={6} sm={4}>{props.data.nutcrackerTreatment}</Col>
                            </Row>
                        )}
                    </>
                )}

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Has been Diagnosed with Kidney Disease?</Col>
                    <Col xs={6} sm={4}>{getBoolean(props.data.hasHadKidneyDisease)}</Col>
                </Row>

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Has had a Heart Attack?</Col>
                    <Col xs={6} sm={4}>{getBoolean(props.data.hasHadHeartAttack)}</Col>
                </Row>

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Has Diabetes?</Col>
                    <Col xs={6} sm={4}>{getBoolean(props.data.hasDiabetes)}</Col>
                </Row>

                {props.data.hasDiabetes && (
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8} className='item-label'>&nbsp; - BG maintained by:</Col>
                        <Col xs={6} sm={4}>{props.data.diabetesStatus}</Col>
                    </Row>
                )}

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Has had Cancer?</Col>
                    <Col xs={6} sm={4}>{getBoolean(props.data.hasHadCancer)}</Col>
                </Row>

                {props.data.hasHadCancer && (<>
                    <Row className='row-underlined row-value-center'>
                        <Col xs={12}>
                            <Table striped className='nkr-data-table'>
                                <thead>
                                    <tr>
                                        <th>Type</th>
                                        <th>Remission</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {props.data.cancers.map(cancer => {
                                        const type = CancerType[cancer.cancerType];
                                        const remission = RemissionStatus[cancer.remissionStatus];
                                        return (
                                            <tr key={cancer.cancerType}>
                                                <td>{type}</td>
                                                <td>{remission}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </>)}

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Has had Kidney Stones?</Col>
                    <Col xs={6} sm={4}>{getBoolean(props.data.hasHadKidneyStones)}</Col>
                </Row>

                {props.data.hasHadKidneyStones && (
                    <>
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>&nbsp; - number of episodes?</Col>
                            <Col xs={6} sm={4}>{props.data.kidneyStoneEpisodes}</Col>
                        </Row>
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>&nbsp; - remission status?</Col>
                            <Col xs={6} sm={4}>{props.data.kidneyStoneRemissionStatus}</Col>
                        </Row>
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>&nbsp; - treatment?</Col>
                            <Col xs={6} sm={4}>{props.data.kidneyStoneTreatment}</Col>
                        </Row>
                    </>
                )}

                {props.data.gender == 'Female' && (
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8} className='item-label'>Has ever been Pregnant?</Col>
                        <Col xs={6} sm={4}>{getBoolean(props.data.hasBeenPregnant)}</Col>
                    </Row>
                )}

                {props.data.hasBeenPregnant && (
                    <>
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>&nbsp; - Is Currently Pregnant?</Col>
                            <Col xs={6} sm={4}>{getBoolean(props.data.isPregnant)}</Col>
                        </Row>
                        {!props.data.isPregnant && (
                            <Row className='row-underlined row-value-center'>
                                <Col xs={6} sm={8} className='item-label'>&nbsp; - Months Since Pregnancy?</Col>
                                <Col xs={6} sm={4}>
                                    {props.data.monthsSincePregnant == 24 ? '24+' : props.data.monthsSincePregnant}
                                </Col>
                            </Row>
                        )}
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>&nbsp; - Is Currently Nursing?</Col>
                            <Col xs={6} sm={4}>{getBoolean(props.data.isNursing)}</Col>
                        </Row>
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>&nbsp; - Gestational Diabetes?</Col>
                            <Col xs={6} sm={4}>{getBoolean(props.data.hadGestationalDiabetes)}</Col>
                        </Row>

                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>&nbsp; - Hypertension during pregnancy?</Col>
                            <Col xs={6} sm={4}>{getMedicalStatus(props.data.hadHighBpDuringPregnancy)}</Col>
                        </Row>
                    </>
                )}

                {props.data.gender == 'Female' && (<>
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8} className='item-label'>Is Planning on Pregnancy?</Col>
                        <Col xs={6} sm={4}>{getBoolean(props.data.isPlanningOnPregnancy)}</Col>
                    </Row>

                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8} className='item-label'>Is Taking Birth Control?</Col>
                        <Col xs={6} sm={4}>{getBoolean(props.data.isTakingBirthControl)}</Col>
                    </Row>
                </>)}
                {props.data.isTakingBirthControl && (
                    <>
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>&nbsp; - Months on Birth Control</Col>
                            <Col xs={6} sm={4}>{props.data.birthControlMonths}</Col>
                        </Row>
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>&nbsp; - Birth Control Form</Col>
                            <Col xs={6} sm={4}>{props.data.birthControlForm}</Col>
                        </Row>
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>&nbsp; - Birth Control Complications</Col>
                            <Col xs={6} sm={4}>{props.data.birthControlComplications}</Col>
                        </Row>
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>&nbsp; - Is Able to Stop Birth Control</Col>
                            <Col xs={6} sm={4}>{getBoolean(props.data.isAbleToStopBirthControl, false)}</Col>
                        </Row>
                    </>
                )}

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Has Used Tobacco</Col>
                    <Col xs={6} sm={4}>{getBoolean(props.data.hasUsedTobacco)}</Col>
                </Row>

                {props.data.hasUsedTobacco && (
                    <>
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>&nbsp; - Currently uses Tobacco?</Col>
                            <Col xs={6} sm={4}>{getBoolean(props.data.usesTobacco)}</Col>
                        </Row>
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>&nbsp; - Will Stop for Surgery?</Col>
                            <Col xs={6} sm={4}>
                                {props.data.usesTobacco ? getBoolean(props.data.willStopTobaccoUse, false) : 'N/A'}
                            </Col>
                        </Row>
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>&nbsp; - How Many Years:</Col>
                            <Col xs={6} sm={4}>{getNumber(props.data.tobaccoYears)}</Col>
                        </Row>
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>
                                &nbsp; - Tobacco use (packs/cans) / Frequency:
                            </Col>
                            <Col xs={6} sm={4}>
                                {getNumber(props.data.tobaccoPacks)} / {getString(props.data.tobaccoFrequency)}
                            </Col>
                        </Row>
                    </>
                )}

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Has HIV?</Col>
                    <Col xs={6} sm={4}>{getYesNoUnknown(props.data.hasHiv)}</Col>
                </Row>

                {/* <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Is Currently Incarcerated?</Col>
                    <Col xs={6} sm={4}>{getBoolean(props.data.isCurrentlyIncarcerated)}</Col>
                </Row> */}

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Is Currently Residing in U.S.?</Col>
                    <Col xs={6} sm={4}>{getBoolean(props.data.isResidingInUsa, false)}</Col>
                </Row>

                {!props.data.isResidingInUsa && (
                    <>
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>&nbsp; - Is seeking compensation?</Col>
                            <Col xs={6} sm={4}>{getBoolean(props.data.isDonatingForCompensation)}</Col>
                        </Row>
                    </>
                )}
            </div>
        </div>
    );
}

export default PreScreening;